import { render, staticRenderFns } from "./mostRatedCategories.vue?vue&type=template&id=2b6e2992"
import script from "./mostRatedCategories.vue?vue&type=script&lang=ts"
export * from "./mostRatedCategories.vue?vue&type=script&lang=ts"
import style0 from "./mostRatedCategories.vue?vue&type=style&index=0&id=2b6e2992&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports